import BsStatus from './index.vue'
export default BsStatus